<div class="block-ui">
    <i class="fas fa-exclamation-triangle" style="color: #ffae42; font-size: 50px;"></i>
    <h3>SECCION BLOQUEADA, <br> SELECCIONE O CREE UN HUB</h3>
</div>
